import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 25 24"

const AccountIcon = createSvgIcon(
  <>
    <path d='M12.1 14.2c2.6 0 4.7-2.4 4.7-5.3s-2.1-5.3-4.7-5.3S7.4 6 7.4 8.9s2.1 5.3 4.7 5.3zm0-9.6c2.1 0 3.7 1.9 3.7 4.3s-1.7 4.3-3.7 4.3c-2.1 0-3.7-1.9-3.7-4.3s1.6-4.3 3.7-4.3z' />
    <path d='M12.1 0C5.5 0 .1 5.4.1 12c0 3.1 1.2 6 3.2 8.1 0 .1.1.1.1.1 2.2 2.3 5.3 3.8 8.7 3.8 6.6 0 12-5.4 12-12s-5.4-12-12-12zm0 1c6.1 0 11 4.9 11 11 0 2.6-.9 4.9-2.4 6.8-1.2-2.1-3.4-3.4-5.8-3.4H9.2c-2.4 0-4.6 1.3-5.8 3.3C2 16.9 1.1 14.6 1.1 12c0-6.1 4.9-11 11-11zm0 22c-3.1 0-5.9-1.3-7.9-3.4 1-1.9 2.9-3.2 5.1-3.2H15c2.2 0 4.1 1.2 5.1 3.2-2.1 2.1-4.9 3.4-8 3.4z' />
  </>,
  'AccountIcon'
)

export default AccountIcon
